import {
    Box, Dialog, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    Select,
    Tab,
    Tabs,
    Tooltip,
    useTheme, Theme
} from "@mui/material";
import "./CampCreateSession.scss";
import { useEffect, useRef, useState } from "react";
import { SelectChangeEvent } from '@mui/material/Select';
import { Field, Formik } from "formik";
import {
    ADMIN_ROLES,
    API_RESPONSE,
    COMMON_CONSTANTS,
    CREATE_SESSIONS_FIELD,
    MODES,
    NUMBER_CONSTANTS,
    PAYLOAD_KEYS,
    PERSONAL_INFORMATION,
    ROUTES,
    SESSIONS_ERROR_MESSAGE,
    STORAGE_KEYS,
    TOASTER_CONFIGS,
    VALIDATION_CONSTANT,
} from "../../../../Utilities/Constants/Constants";
import {
    GetSessionStorageData,
    S3DataGetApi,
    checkValueNullUndefinedEmpty,
    nullUndefinedEmptyCheck,
    numberOnly,
    uploadFileToS3,
} from "../../../../Services/Helpers/Helper";
import * as yup from "yup";
import { toast } from "react-toastify";
import { DatePicker, TimeField } from "@mui/x-date-pickers";
import {
    ERROR_MESSAGES,
    REGEX,
    REGISTRATION_ERRORS,
} from "../../../../Utilities/Constants/Validations";
import uploadImage from "../../../../../Assets/Registration/feather_upload-cloud-icon.svg";
import pdfImage from "../../../../../Assets/global/pdf_icon.svg";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns/AdapterDateFns";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { blue } from "@mui/material/colors";
import CloseIcon from "@mui/icons-material/Close";
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import DeleteEventDialog from "../DeleteEventDialog/DeleteEventDialog";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import close from "../../../../../Assets/Sessions/close.svg"
import { getHours, getMinutes, parse, set } from "date-fns";
import { store } from "../../../../Services/Redux/Store/Store";
import { setLoader } from "../../../../Services/Redux/Reducer/Reducer";
import coverImageIcon from "../../../../../Assets/global/image-cover.svg";
import { useSelector } from "react-redux";
import CategoryValidationDialog from "../../../../Shared/CategoryValidationDialog/CategoryValidationDialog";

const CampCreateSessionDialog = (props: any) => {
    const uploadFileRef = useRef<HTMLInputElement | null>(null);
    //   const [dialogOpenStatus, setDialogOpenStatus] = useState(false);
    const [eventTitle, setEventTitle] = useState("");
    const [viewerFile, setViewerFile] = useState("");
    const [deleteDialogStatus, setDeleteDialogStatus] = useState(API_RESPONSE.FALSE);
    const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
    const [customSelectedDays, setCustomSelectedDays]: any = useState([]);
    const [categoryId, setCategoryId] = useState<Number>()
    const initValues = {
        [CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE]: "",
        [CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE_ARABIC]: "",
        [CREATE_SESSIONS_FIELD.DESCRIPTION]: "",
        [CREATE_SESSIONS_FIELD.AGE_MIN]: "",
        [CREATE_SESSIONS_FIELD.AGE_MAX]: "",
        [CREATE_SESSIONS_FIELD.AMENITY]: [],
        [CREATE_SESSIONS_FIELD.GENDER]: "",
        [CREATE_SESSIONS_FIELD.CATEGORY]: "",
        //   [CREATE_SESSIONS_FIELD.GRADE]: "",
        // [CREATE_SESSIONS_FIELD.SESSION_START_DATE]: "",
        // [CREATE_SESSIONS_FIELD.SESSION_END_DATE]: "",
        [CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]: "",
        [CREATE_SESSIONS_FIELD.SYLLABUS_FILE]: "",
        [CREATE_SESSIONS_FIELD.BATCH_SIZE]: "",
        [CREATE_SESSIONS_FIELD.COURSE_TYPE]: `${NUMBER_CONSTANTS.TWO}`,
        [CREATE_SESSIONS_FIELD.SLOT_MODE]: `${CREATE_SESSIONS_FIELD.DAILY}`,
        [CREATE_SESSIONS_FIELD.TOTAL_DAYS]: `${NUMBER_CONSTANTS.NINETY}`
    }
    const [sessionInitialValue, setSessionInitialValue]: any = useState(initValues);
    const [syllabusFile, setSyllabusFile]: any = useState([]);
    const [categoryList, setCategoryList]: any = useState([]);
    const [slotData, setSlotData]: any = useState();
    const [formSubmitted, setFormSubmitted] = useState(API_RESPONSE.FALSE);
    const uploadFileBtnRef = useRef<HTMLInputElement | null>(API_RESPONSE.NULL);
    const [startDate, setStartDate]: any = useState("");
    const [endDate, setEndDate]: any = useState("");
    const [fixedEndDate, setFixedEndDate]: any = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime]: any = useState("");
    const [repeatType, setRepeatType] = useState("");
    const [mode, setMode] = useState("");
    const [eventInitialValue, setEventInitialValue]: any = useState();
    const [sessionDetail, setSessionDetail]: any = useState();
    const [payloadCategory, setPayloadCategory]: any = useState();
    const [initialRender, setInitialRender] = useState(API_RESPONSE.TRUE);
    const [gradesList, setGradesList]: any = useState([]);
    const [roleId, setRoleId] = useState('');
    const [sessionName, setSessionName] = useState("");
    const [equipmentsList, setEquipmentsList]: any = useState([]);
    const [aminityList, setAminityList]: any = useState([]);
    const [equipmentsPoint, setEquipmentsPoint]: any = useState("");
    const [categoryValidationDetails, setCategoryValidationDetails] = useState<any>("")
    const [categoryValidationMessage, setCategoryValidationMessage] = useState<any>("")
    const [open, setOpen] = useState<boolean>(false)
    const navigate = useNavigate();
    const currentDate = new Date();
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const minTime = `${hours}:${minutes}`;
    const [curentTabIndex, setCurrentTabIndex] = useState(NUMBER_CONSTANTS.ZERO);
    const [status, setstatus] = useState<any>("")
    console.log("🚀 ~ CampCreateSessionDialog ~ status:", status)
    const theme = useTheme();

    const [personName, setPersonName] = useState<any>([]);
    const aws: any = useSelector((state: any) => {
        return state.awsReducer.aws;
    });

    const handleClose = () => {
        setOpen(false)
        onClose()
      }

    const handleChangeMultiple = (event: SelectChangeEvent<typeof personName>) => {
        const { target: { value }, } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    useEffect(() => {
    }, [personName])

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    function getStyles(name: string, personName: string[], theme: Theme) {
        return {
            fontWeight:
                personName.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }
    /* YUP validation schema */
    const sessionValidatinSchema: any = yup.object({
        [CREATE_SESSIONS_FIELD.CATEGORY]: yup
            .mixed()
            .required(SESSIONS_ERROR_MESSAGE.CATEGORY_REQUIRED),
        [CREATE_SESSIONS_FIELD.SLOT_MODE]: yup
            .string()
            .required(SESSIONS_ERROR_MESSAGE.SLOT_MODE),
        [CREATE_SESSIONS_FIELD.COURSE_TYPE]: yup
            .string(),
        [CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]: yup
            .string(),
        // .required(SESSIONS_ERROR_MESSAGE.PRICE_PER_HOUR_REQUIRED),
        [CREATE_SESSIONS_FIELD.TOTAL_DAYS]: yup
            .string()
            .required(SESSIONS_ERROR_MESSAGE.TOTAL_DAYS),
        // [CREATE_SESSIONS_FIELD.SYLLABUS_FILE]: yup.string(),
        [CREATE_SESSIONS_FIELD.EQUIPMENTS]: yup
            .string(),
        // .required(SESSIONS_ERROR_MESSAGE.EQUIPMENTS_NEEDED),
        [CREATE_SESSIONS_FIELD.BATCH_SIZE]: roleId === ADMIN_ROLES.RECREATIONAL_CAMP ? yup
            .string()
            .required(SESSIONS_ERROR_MESSAGE.BATCH_SIZE)
            :
            yup
                .string()
    });
    const freeSessionValidatinSchema: any = yup.object({

        [CREATE_SESSIONS_FIELD.SLOT_MODE]: yup
            .string()
            .required(SESSIONS_ERROR_MESSAGE.SLOT_MODE),

        [CREATE_SESSIONS_FIELD.TOTAL_DAYS]: yup
            .string()
            .required(SESSIONS_ERROR_MESSAGE.TOTAL_DAYS)
    });

    /* Dialog close function */
    const onClose = () => {
        setFormSubmitted(API_RESPONSE.FALSE);
        setSyllabusFile([]);
        setCustomSelectedDays([]);
        setStartDate("");
        setEndDate("");
        setStartTime("");
        setEndTime("");
        setRepeatType("");
        setSessionInitialValue(initValues)
        return props.dialogStatus(API_RESPONSE.FALSE);
    };

    /* Generating session name based on SP_ID,Activity and session start time */
    useEffect(() => {
        if (payloadCategory && endTime && startTime) {
            let name = payloadCategory[0].activites + '_' + 'SP' + payloadCategory[0].id + '_' + convertRailwayTime(startTime);
            setSessionName(name)
        } else if (curentTabIndex === NUMBER_CONSTANTS.ONE && startTime) {
            let name = 'Free_session' + '_' + convertRailwayTime(startTime);
            setSessionName(name)
        }
    }, [endTime, startTime, payloadCategory])

    const getRoleId = () => {
        let roleId: any = GetSessionStorageData(STORAGE_KEYS.ROLE);
        setRoleId(roleId);
    }

    useEffect(() => {
        if (roleId)
            getRecreationalCategory()
    }, [roleId])

    /* Getting category list */
    useEffect(() => {
        getRoleId();
        getAminityList()
        setFormSubmitted(API_RESPONSE.FALSE);
    }, []);

    /* Setting start date on props update */
    useEffect(() => {
        setSessionInitialValue(initValues)
        setStartDate(props.slotDate);
        findEndDate(props.slotDate);
        setMode(props.mode);


    }, [props.mode]);

    useEffect(() => {
        if (props.mode === MODES.EDIT && aminityList.length > 0) {
            getSessionDetail(props.payload);
        }
    }, [aminityList])


    const getAminityList = () => {
        axiosInstance.get(API_END_POINTS.AMINITY_LIST).then((response) => {
            setAminityList(response.data.result.data)
        });
    }

    /* Recreational category API call */
    const getRecreationalCategory = () => {
        let END_POINT = roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL ?
            API_END_POINTS.PERSONAL_CATEGORY : API_END_POINTS.CAMP_CATEGORY;
        axiosInstance.get(END_POINT).then((response) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                setCategoryList(response.data.result.data);
            }
        });
    };


    /* Getting session detail */
    const getSessionDetail = (payload: any) => {
        axiosInstance.get(API_END_POINTS.SLOT_DETAIL + `?${PAYLOAD_KEYS.SERVICE_SESSION_ID}=` + payload.service_session_id + `&${PAYLOAD_KEYS.TEACH_SERVICE_ID}=` + payload.teach_service + `&${PAYLOAD_KEYS.SLOT_ID}=` + payload.slot_id + `&${PAYLOAD_KEYS.TIMESLOT_ID}=` + payload.timeslot_id).then((response) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                setSessionDetail(response.data.result.data);
                setInitialData(response.data.result.data.recreationalcamp_session);
                setCategoryId(response?.data?.result?.data?.recreationalcamp_session?.category)
                setstatus(response?.data?.result?.data?.recreationalcamp_session?.status)
                setEventInitialValue(response.data.result.data.recreationalcamp_session);
            }
        });
    };

    /*geting seteled category detailes */
  const getValidateCategoryDetailes = () => {
    axiosInstance.get(API_END_POINTS.MANAGE_CATEGORY)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        setCategoryValidationDetails(res.data.result.data)
        setOpen(true)
      }
    })
  }

  /*undate or accept commision change */
  const putValidationCategory = () => {
    let payload = {
      "id":categoryValidationDetails?.id, 
      "category_id": categoryValidationDetails?.category_id ,
      "teach_service_provider_id": categoryValidationDetails?.teach_service_provider,
      "status":"accepted"
    }
    axiosInstance.put(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        handleClose()
      }
    })
  }

    /* Setting initial value */
    const setInitialData = (data: any) => {
        let formattedStartTime = `${moment(props.payload.start).format(COMMON_CONSTANTS.YMD_FORMAT)}` + COMMON_CONSTANTS.LETTER_T + `${data?.start_time}`;
        let formattedEndTime = `${data?.end_date}` /* + COMMON_CONSTANTS.LETTER_T + `${data?.end_time}` */;
        setSessionInitialValue({
            [CREATE_SESSIONS_FIELD.CATEGORY]: data?.category_name,
            [CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]: parseFloat(data.total_class_fee) / parseInt(data?.total_class),
            [CREATE_SESSIONS_FIELD.EQUIPMENTS]: data.equipments ? data.equipments : '',
            [CREATE_SESSIONS_FIELD.BATCH_SIZE]: data.batch_size ? `${data.batch_size}` : '',
            [CREATE_SESSIONS_FIELD.COURSE_TYPE]: `${NUMBER_CONSTANTS.TWO}`,
            [CREATE_SESSIONS_FIELD.SLOT_MODE]: data?.slot_mode,
            [CREATE_SESSIONS_FIELD.TOTAL_DAYS]: data?.total_class,
            [CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE]: data.camp_session_title,
            [CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE_ARABIC]: data.arabic_camp_session_title || "" ,
            [CREATE_SESSIONS_FIELD.DESCRIPTION]: data.description,
            [CREATE_SESSIONS_FIELD.AGE_MIN]: data.min_age,
            [CREATE_SESSIONS_FIELD.AGE_MAX]: data.max_age,
            [CREATE_SESSIONS_FIELD.AMENITY]: [...data.amenities],
            [CREATE_SESSIONS_FIELD.GENDER]: data.gender,
            //   [CREATE_SESSIONS_FIELD.GRADE]: "",
            // [CREATE_SESSIONS_FIELD.SESSION_START_DATE]: "",
            // [CREATE_SESSIONS_FIELD.SESSION_END_DATE]: "",
            // [CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]: "",
            // [CREATE_SESSIONS_FIELD.SYLLABUS_FILE]: "",

        });
        /*  let persons:any = []
        data.amenities.map((val:any,i:number)=>{
             persons.push(val.amenity_name);
        });       */
        setSessionName(data?.session_title);
        setEquipmentsList(data?.additional_notes)
        setRepeatType(data?.slot_mode);
        setEndDate(data?.end_date);
        setStartDate(moment(props.payload.start).format(COMMON_CONSTANTS.YMD_FORMAT));
        setEndTime(formattedEndTime);
        setStartTime(formattedStartTime);
        setSyllabusFile(data.study_materials);
        setCustomSelectedDays(data?.days);
        setSyllabusFile([data?.camp_images]);
        let resAminityList: any = aminityList.filter((resp: any, i: number) => {
            return data?.amenities.some((obj: any) => {
                return obj.amenity_name === resp.value
            })
        });
        setPersonName([...resAminityList]);
        let categoryIndex = categoryList.filter(
            (item: any) => item.activites === data.category_name
        );
        if (categoryIndex.length > 0){
            setPayloadCategory(categoryIndex);
        }

    };

    /* Media upload function */
    const uploadFiles = async (file: any) => {
        store.dispatch(setLoader(true));
        const uploadedImage: any = await S3DataGetApi(file);
        setSyllabusFile([...syllabusFile, uploadedImage]);
        store.dispatch(setLoader(false));
    };

    const handleBtnClick = () => {
        uploadFileBtnRef.current?.click();
    };

    /* Handling delete in syllabus cover file */
    const handleDelete = (i: any) => {
        let data = syllabusFile;
        data.splice(i, NUMBER_CONSTANTS.ONE);
        setSyllabusFile([...data]);
    }

    /* Handling drag over */
    const handleDragOver = (event: any) => {
        event.preventDefault();
    };

    /* Handling file drop */
    const handleDrop = (event: any) => {
        event.preventDefault();
        event.nativeEvent.preventDefault();
        checkUploadType(event, PERSONAL_INFORMATION.DROP)
            .then((status) => {
                uploadFiles(event);
            })
            .catch((error) => {
                toast.error(error);
            });
    };

    /* Handling file drag */
    const handleDragEnter = (event: any) => {
        event.preventDefault();
    };

    /* Handling file drag leave */
    const handleDragLeave = (event: any) => {
        event.preventDefault();
    };

    /* Checking upload type */
    const checkUploadType = (event: any, uploadingType: any) => {
        store.dispatch(setLoader(true));
        return new Promise((resolve, reject) => {
            const eventValue: any =
                uploadingType === PERSONAL_INFORMATION.DROP
                    ? event.dataTransfer.files
                    : event.target.files;
            const isValid: any = [...eventValue].every((media: any) => {
                if (
                    media.type.split("/")[NUMBER_CONSTANTS.ONE] ===
                    COMMON_CONSTANTS.PDF ||
                    media.type.split("/")[NUMBER_CONSTANTS.ZERO] ===
                    COMMON_CONSTANTS.IMAGE
                ) {
                    return API_RESPONSE.TRUE;
                }
                return API_RESPONSE.FALSE;
            });

            if (isValid) {
                resolve(API_RESPONSE.TRUE);
            } else {
                reject(API_RESPONSE.FALSE);
            }
        });
    };


    /* Set type of repeat */
    const setRepeat = (type: any) => {
        setRepeatType(type);
    };

    /* Setting slot end date  */
    const findEndDate = (start: any) => {
        const date = new Date(start);
        let finalDate = new Date(date.setDate(date.getDate() + NUMBER_CONSTANTS.NINETY));
        setEndDate(moment(finalDate).format(COMMON_CONSTANTS.MDY_FORMAT));
        setFixedEndDate(moment(finalDate).format(COMMON_CONSTANTS.MDY_FORMAT));

    }

    useEffect(() => {
    }, [customSelectedDays])

    /* Adding custom week days */
    const onClickDay = (day: any) => {
        if (customSelectedDays.includes(day)) {
            let filteredDays = customSelectedDays.filter(
                (i: any) => i !== day
            );
            setCustomSelectedDays(filteredDays);
        } else {
            let addedDays = customSelectedDays;
            addedDays.push(day);
            setCustomSelectedDays([...addedDays]);
        }

    }


    /* Setting category object */
    const onSetCategory = (value: any, setFieldValue: any) => {
        if (nullUndefinedEmptyCheck(value)) {
            let data = categoryList.filter(
                (item: any) => item.activites === value
            );
            //   setGradesList(data[0].grade);
            setFieldValue(
                CREATE_SESSIONS_FIELD.PRICE_PER_HOUR,
                data[NUMBER_CONSTANTS.ZERO].final_fee
            );
            setSessionInitialValue[CREATE_SESSIONS_FIELD.PRICE_PER_HOUR] =
                data[NUMBER_CONSTANTS.ZERO].final_fee;
            setPayloadCategory(data);
        } else {
            setFieldValue(
                CREATE_SESSIONS_FIELD.PRICE_PER_HOUR,
                ""
            );
        }
    };

    /* Setting grade object */
    const onSetGrade = (value: any, setFieldValue: any) => {
        let data = gradesList.filter(
            (item: any) => item.grade_name === value
        );
        setFieldValue(
            CREATE_SESSIONS_FIELD.PRICE_PER_HOUR,
            data[NUMBER_CONSTANTS.ZERO].fees
        );
        setSessionInitialValue[CREATE_SESSIONS_FIELD.PRICE_PER_HOUR] =
            data[NUMBER_CONSTANTS.ZERO].fees;
    };

    const onAddEqipmentPoint = () => {
        if (nullUndefinedEmptyCheck(equipmentsPoint)) {
            setEquipmentsList([...equipmentsList, equipmentsPoint]);
            setEquipmentsPoint("");
        }
    }

    const onRemoveEquipPoint = (index: any) => {
        let list: any = equipmentsList;
        list.splice(index, NUMBER_CONSTANTS.ONE);
        setEquipmentsList([...list])
    };


    /* Handling file change */
    const handleChange = (event: any) => {
        store.dispatch(setLoader(true));
        checkUploadType(event, PERSONAL_INFORMATION.SELECT)
            .then((status) => {
                uploadFiles(event);
                store.dispatch(setLoader(false));
            })
            .catch((error) => {
                toast.error(error);
                store.dispatch(setLoader(false));
            });
    };

    /**Handle file viewer dialog open */
    const onFilerViewerDialogOpen = (url: any) => {
        setViewerFile(url);
        setFileViewerOpen(API_RESPONSE.TRUE);
    };

    /* Coverting intoo railway time */
    const convertRailwayTime = (time: any) => {
        return moment(time, COMMON_CONSTANTS.HMA_FORMAT).format(COMMON_CONSTANTS.HM_FORMAT);
    };

    useEffect(() => {
    }, [endTime])

    useEffect(() => {
        setEndDate("");
        setFixedEndDate("");
        setStartTime("");
        setEndTime("");
        setRepeatType("");
    }, [curentTabIndex]);

    /* Create Session API call */
    const onCreateSession = (values: any, resetForm: any, setField: any) => {
        const payloadData = {...values};
        if (curentTabIndex === NUMBER_CONSTANTS.ZERO) {
            const currentDateTime = moment(startDate);
            const startTimeString = startTime;
            const formattedStartTime = moment(startTimeString, COMMON_CONSTANTS.HOUR_MINUTE_SEC);
            const mergedStartDateTime = currentDateTime.set({
                hour: formattedStartTime.hour(),
                minute: formattedStartTime.minute(),
                second: formattedStartTime.second(),
            });

            const currentDateTime2 = moment(startDate);
            const endTimeString = endTime;
            const formattedEndTime = moment(endTimeString, COMMON_CONSTANTS.HOUR_MINUTE_SEC);
            const mergedEndDateTime = currentDateTime2.set({
                hour: formattedEndTime.hour(),
                minute: formattedEndTime.minute(),
                second: formattedEndTime.second(),
            });

            const AminityPayload = personName?.map((item: any) => {
                return [
                    {
                        amenity_icon: item.icon,
                        amenity_name: item.value
                    },
                ]
            })
            const currentDate = moment(new Date()).format(COMMON_CONSTANTS.YMD_HSC)
            if (
                // convertRailwayTime(new Date(endTime)) > convertRailwayTime(new Date(startTime)) &&
                ((convertRailwayTime(new Date(endTime)) > convertRailwayTime(new Date(startTime))) ||
                    convertRailwayTime(new Date(endTime)) === "00:00" && convertRailwayTime(new Date(endTime)) !==
                    convertRailwayTime(new Date(startTime))
                ) &&
                startDate &&
                payloadData.total_days > NUMBER_CONSTANTS.ZERO &&
                payloadData.total_days <= NUMBER_CONSTANTS.NINETY &&
                mergedStartDateTime.isAfter(currentDate) &&
                ((repeatType === "custom" && customSelectedDays.length > NUMBER_CONSTANTS.ZERO) || repeatType !== "custom")
            ) {
                payloadData.start_time = moment(startTime, [
                    COMMON_CONSTANTS.HMA_FORMAT,
                ]).format(COMMON_CONSTANTS.HM_FORMAT);
                payloadData.end_time = moment(endTime, [COMMON_CONSTANTS.HMA_FORMAT]).format(
                    COMMON_CONSTANTS.HM_FORMAT
                );
                payloadData.service_type = roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL ? VALIDATION_CONSTANT.PERSONAL : VALIDATION_CONSTANT.CAMP;
                let category_item = categoryList.find((res: any, i: number) => {
                    return res.activites === payloadData.category;
                })
                payloadData.category = category_item;
                payloadData.start_date = moment(startDate).format(COMMON_CONSTANTS.YMD_FORMAT);
                payloadData.slot_dates = {
                    date_ranges: [],
                    single_date: [],
                };
                payloadData.end_date = "";
                payloadData.days = [];
                payloadData.camp_images = syllabusFile;
                payloadData.amenities = AminityPayload ? AminityPayload.flat() : [];
                payloadData.slot_price = payloadData.pricePerHour;
                payloadData.avg_fees_per_slot = payloadData.pricePerHour;
                payloadData.total_class_fee = (payloadData.pricePerHour * payloadData.total_days).toString();
                if (repeatType === CREATE_SESSIONS_FIELD.CUSTOM) {
                    payloadData.end_date = moment(endDate).format(COMMON_CONSTANTS.YMD_FORMAT);
                    payloadData.days = customSelectedDays;
                };
                if (props.mode === MODES.EDIT) {
                    payloadData.session_id = eventInitialValue.id
                } else {
                    setField(CREATE_SESSIONS_FIELD.CATEGORY, payloadCategory[NUMBER_CONSTANTS.ZERO].activites);
                }


                payloadData.session_title = sessionName;
                payloadData.free_session = API_RESPONSE.FALSE;
                props.mode !== MODES.EDIT ?
                    axiosInstance
                        .post(API_END_POINTS.CREATE_SESSION, payloadData)
                        .then((response) => {
                            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                                toast.success(response.data.message, TOASTER_CONFIGS);
                                setFormSubmitted(API_RESPONSE.FALSE);
                                setSyllabusFile([]);
                                setCustomSelectedDays([]);
                                setStartDate("");
                                setEndDate("");
                                setStartTime("");
                                setEndTime("");
                                setRepeatType("");
                                onClose();

                            }
                        })
                    :
                    axiosInstance
                        .put(API_END_POINTS.CREATE_SESSION, payloadData)
                        .then((response) => {
                            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                                toast.success(response.data.message, TOASTER_CONFIGS);
                                setFormSubmitted(API_RESPONSE.FALSE);
                                setSyllabusFile([]);
                                setCustomSelectedDays([]);
                                setStartDate("");
                                setEndDate("");
                                setStartTime("");
                                setEndTime("");
                                setRepeatType("");
                                onClose();

                            }
                        })
            } else {
                
                if (payloadData.total_days > NUMBER_CONSTANTS.NINETY) {
                    toast.error(ERROR_MESSAGES.SESSION_TOTAL_DAYS)
                } else if (convertRailwayTime(startTime) < convertRailwayTime(minTime)) {
                    toast.error(ERROR_MESSAGES.START_TIME)
                }
                else if (convertRailwayTime(endTime) < convertRailwayTime(minTime)) {
                    toast.error(ERROR_MESSAGES.END_TIME)
                } else {
                    toast.error(ERROR_MESSAGES.INVALID_DATES)
                }
            }
                       
        } else {
            const currentDateTime = moment(startDate);
            const startTimeString = startTime;
            const formattedStartTime = moment(startTimeString, COMMON_CONSTANTS.HOUR_MINUTE_SEC);
            const mergedStartDateTime = currentDateTime.set({
                hour: formattedStartTime.hour(),
                minute: formattedStartTime.minute(),
                second: formattedStartTime.second(),
            });

            const currentDate = moment(new Date()).format(COMMON_CONSTANTS.YMD_HSC)
            if (
                startDate &&
                payloadData.total_days > NUMBER_CONSTANTS.ZERO &&
                payloadData.total_days <= NUMBER_CONSTANTS.NINETY &&
                mergedStartDateTime.isAfter(currentDate) &&
                ((repeatType === "custom" && customSelectedDays.length > NUMBER_CONSTANTS.ZERO) || repeatType !== "custom")
            ) {
                payloadData.start_time = moment(startTime, [
                    COMMON_CONSTANTS.HMA_FORMAT,
                ]).format(COMMON_CONSTANTS.HM_FORMAT);

                payloadData.service_type = roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL ? VALIDATION_CONSTANT.PERSONAL : VALIDATION_CONSTANT.CAMP;
                payloadData.start_date = moment(startDate).format(COMMON_CONSTANTS.YMD_FORMAT);
                payloadData.slot_dates = {
                    date_ranges: [],
                    single_date: [],
                };
                payloadData.grade = '';
                payloadData.end_date = '';
                payloadData.days = [];
                payloadData.days = [];
                if (repeatType === CREATE_SESSIONS_FIELD.CUSTOM) {
                    payloadData.end_date = moment(endDate).format(COMMON_CONSTANTS.YMD_FORMAT);
                    payloadData.days = customSelectedDays;
                };
                setField(CREATE_SESSIONS_FIELD.CATEGORY, payloadCategory[NUMBER_CONSTANTS.ZERO].activites);
                payloadData.session_title = sessionName;
                payloadData.free_session = API_RESPONSE.TRUE;
                axiosInstance
                    .post(API_END_POINTS.CREATE_SESSION, payloadData)
                    .then((response) => {
                        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                            toast.success(response.data.message, TOASTER_CONFIGS);
                            setFormSubmitted(API_RESPONSE.FALSE);
                            setSyllabusFile([]);
                            setCustomSelectedDays([]);
                            setStartDate("");
                            setEndDate("");
                            setStartTime("");
                            setEndTime("");
                            setRepeatType("");
                            onClose();

                        }
                    })
            } else {
                if (payloadData.total_days > NUMBER_CONSTANTS.NINETY) {
                    toast.error(ERROR_MESSAGES.SESSION_TOTAL_DAYS)
                } else if (convertRailwayTime(startTime) < convertRailwayTime(minTime)) {
                    toast.error(ERROR_MESSAGES.START_TIME)
                }
                else if (convertRailwayTime(endTime) < convertRailwayTime(minTime)) {
                    toast.error(ERROR_MESSAGES.END_TIME)
                }
            }

        }
    };

    const onCloseDialog = () => {
        setDeleteDialogStatus(API_RESPONSE.FALSE);
        onClose();
    };

    /**Handle file viewer dialog close */
    const onFilerViewerDialogClose = () => {
        setFileViewerOpen(API_RESPONSE.FALSE);
        setViewerFile("");
    };

    return (
        <div className="session-dialog-wrapper">

            <FileViewerDialog
                open={fileViewerOpen}
                handleClose={onFilerViewerDialogClose}
                viewerFile={viewerFile}
            ></FileViewerDialog>
            {mode === MODES.EDIT && <DeleteEventDialog modalState={deleteDialogStatus} currentDate={props?.payload?.start} payload={sessionDetail} openStatus={onCloseDialog} />}
            <Dialog
                className="recreational-dialog"
                open={props.modalState}
                sx={{ "& .MuiDialog-paper": "cus-dialog" }}
            >
                <Formik
                    initialValues={sessionInitialValue}
                    // validationSchema={sessionValidatinSchema}
                    enableReinitialize={true}
                    onSubmit={(values, actions) => {
                        let payload = {
                            "category_id": categoryId || null
                        }
                        axiosInstance.post(API_END_POINTS.MANAGE_CATEGORY, payload)
                          .then(
                            (res:any) => {
                              if(!res.data.result.data.status) {
                                getValidateCategoryDetailes()
                                setCategoryValidationMessage(res.data.message)
                              } else {
                                onCreateSession(values, actions.resetForm, actions.setFieldValue);
                              }
                            }
                          ).catch((error)=>{console.log(error)})
                    }}>
                    {(formik: any) => {
                        return (
                            <>
                                <DialogTitle className="title-wrap">
                                    <div className="d-flex gap-3 aligin-items-center">
                                        <h4 className="title">{"Manage Session"}</h4>
                                        { status && <div className="approval-label mt-1 position-relative p-1">
                                            {status === 'approved' ? "Approved" :  status === 'rejected' ? "Rejected" : "Approval Pending"}
                                        </div>}
                                    </div>
                                    <div className="close-wrap">
                                        {mode === MODES.EDIT && <DeleteTwoToneIcon className="delete-icon" onClick={() => { setDeleteDialogStatus(true) }} />}
                                        <CloseIcon className="close-icon" onClick={() => { onClose() }} />
                                    </div>
                                </DialogTitle>

                                <DialogContent>

                                    <div className="create_sessions_card">
                                        <div className="sessions_title"></div>
                                        <div className="sessions_description"></div>

                                        {props.mode !== MODES.EDIT && <Box sx={{ bgcolor: "background.paper" }}>
                                            <Tabs
                                                value={curentTabIndex}
                                                onChange={(e: any, value: number) => {
                                                    // setCurrentIndex(value);
                                                }}
                                                indicatorColor="primary"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                aria-label="scrollable auto tabs example"
                                            >
                                                <Tab className="tab-text" value={NUMBER_CONSTANTS.ZERO} label={<div className="menu-label" onClick={() => setCurrentTabIndex(NUMBER_CONSTANTS.ZERO)}>Paid Session</div>} />
                                            </Tabs>
                                        </Box>}

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Camp Session Title</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE}
                                                        className="email-input"
                                                        placeholder="Camp Session Title"
                                                        value={formik.values[CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE]}
                                                        onBlur={formik.handleBlur}
                                                        disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                        onChange={(e: any) => {
                                                            formik.setFieldValue(
                                                                CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE,
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Camp Session Title In Arabic</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE_ARABIC}
                                                        className="email-input"
                                                        placeholder="Camp Session Title In Arabic"
                                                        value={formik.values[CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE_ARABIC]}
                                                        onBlur={formik.handleBlur}
                                                        disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                        onChange={(e: any) => {
                                                            formik.setFieldValue(
                                                                CREATE_SESSIONS_FIELD.CAMP_SESSION_TITLE_ARABIC,
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Minimum Age</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.AGE_MIN}
                                                        className="email-input"
                                                        placeholder="Minimum Age"
                                                        onInput={numberOnly}
                                                        onPaste={numberOnly}
                                                        value={formik.values[CREATE_SESSIONS_FIELD.AGE_MIN]}
                                                        onBlur={formik.handleBlur}
                                                        disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                        onChange={(e: any) => {
                                                            if (e.target.value <= 18) {
                                                                formik.setFieldValue(
                                                                    CREATE_SESSIONS_FIELD.AGE_MIN,
                                                                    e.target.value
                                                                );
                                                            }
                                                        }}
                                                    />
                                                    <p className="file-text mt-1">
                                                        Recommended Minimum Age : 1
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Maximum Age</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.AGE_CATEGORY}
                                                        className="email-input"
                                                        placeholder="Maximum Age"
                                                        onInput={numberOnly}
                                                        onPaste={numberOnly}
                                                        value={formik.values[CREATE_SESSIONS_FIELD.AGE_MAX]}
                                                        disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e: any) => {
                                                            if (e.target.value <= 18) {
                                                                formik.setFieldValue(
                                                                    CREATE_SESSIONS_FIELD.AGE_MAX,
                                                                    e.target.value
                                                                );
                                                            }
                                                        }}
                                                    />
                                                    <p className="file-text mt-1">
                                                        Recommended Maximum Age : 18
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Gender</label>
                                                    <div className="select-wrapper">
                                                        <Field
                                                            as="select"
                                                            name={CREATE_SESSIONS_FIELD.GENDER}
                                                            className="email-input"
                                                            value={formik.values[CREATE_SESSIONS_FIELD.GENDER]}
                                                            onBlur={formik.handleBlur}
                                                            disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                            onChange={(e: any) => {
                                                                formik.setFieldValue(
                                                                    CREATE_SESSIONS_FIELD.GENDER,
                                                                    e.target.value
                                                                );
                                                            }}
                                                        >
                                                            <option value="">Please select gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                            <option value="others">Mix</option>
                                                        </Field>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Amenity</label>
                                                    {/* <Field
                                                        as="multiple"
                                                        name={CREATE_SESSIONS_FIELD.AMENITY}
                                                        className="email-input"
                                                        value={aminityList}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e: any) => {
                                                            const value = e.target.value
                                                            setAminityList(
                                                                // On autofill we get a stringified value.
                                                                typeof value === 'string' ? value.split(',') : value,
                                                            );
                                                            formik.setFieldValue(
                                                                CREATE_SESSIONS_FIELD.AMENITY,
                                                                aminityList
                                                            );
                                                        }}
                                                    >
                                                        <MenuItem value="">Please select aminity</MenuItem>
                                                        <MenuItem value="male">Male</MenuItem>
                                                        <MenuItem value="female">Female</MenuItem>
                                                        <MenuItem value="others">Others</MenuItem>
                                                    </Field> */}
                                                    <FormControl sx={{ m: 1, width: "100%" }}>
                                                        <Select
                                                            labelId="demo-multiple-name-label"
                                                            id="demo-multiple-name"
                                                            multiple
                                                            value={personName}
                                                            className="email-input"
                                                            onChange={handleChangeMultiple}
                                                        // MenuProps={MenuProps}
                                                        >
                                                            {aminityList?.map((name: any, i: any) => (
                                                                <MenuItem
                                                                    key={i}
                                                                    value={name}
                                                                    style={getStyles(name, personName, theme)}
                                                                >
                                                                    <div className="aminity_dropdown_wapper">
                                                                        <img src={name.icon} alt="" />
                                                                        <span>{name.value}</span>
                                                                    </div>

                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>




                                        {curentTabIndex === NUMBER_CONSTANTS.ZERO && <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Activity</label>
                                                    <div className="select-wrapper">
                                                        <Field
                                                            as="select"
                                                            name={CREATE_SESSIONS_FIELD.CATEGORY}
                                                            placeholder="Select category"
                                                            className="email-input"
                                                            disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                            value={formik.values[CREATE_SESSIONS_FIELD.CATEGORY]}
                                                            onBlur={formik.handleBlur}
                                                            onChange={(e: any) => {
                                                                onSetCategory(e.target.value, formik.setFieldValue);
                                                                formik.setFieldValue(
                                                                    CREATE_SESSIONS_FIELD.CATEGORY,
                                                                    e.target.value
                                                                );

                                                            }}
                                                        >
                                                            <option value={""}>Please select activity</option>
                                                            {categoryList.length > NUMBER_CONSTANTS.ZERO &&
                                                                categoryList?.map((file: any) => {
                                                                    return (
                                                                        <option value={file.activites}>{file.activites}</option>
                                                                    );
                                                                })}
                                                        </Field>
                                                    </div>

                                                    <div className="errorMessage">
                                                        {formik.touched[CREATE_SESSIONS_FIELD.CATEGORY] &&
                                                            formik.errors[CREATE_SESSIONS_FIELD.CATEGORY] && (
                                                                <p>
                                                                    {formik.errors[CREATE_SESSIONS_FIELD.CATEGORY]}
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                        {formik.values[CREATE_SESSIONS_FIELD.PRICE_PER_HOUR] && curentTabIndex === NUMBER_CONSTANTS.ZERO && <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Price Per Hour</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.PRICE_PER_HOUR}
                                                        className="email-input"
                                                        placeholder="Price Per Hour"
                                                        onBlur={formik.handleBlur}
                                                        disabled={API_RESPONSE.TRUE}
                                                        value={
                                                            formik.values[CREATE_SESSIONS_FIELD.PRICE_PER_HOUR]
                                                        }
                                                        onChange={formik.handleChange}
                                                    // onBlur={formik.handleBlur(CREATE_SESSIONS_FIELD.PRICE_PER_HOUR)}
                                                    /* onInput={numberOnly}
                                                    onPaste={numberOnly} */
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[
                                                            CREATE_SESSIONS_FIELD.PRICE_PER_HOUR
                                                        ] &&
                                                            formik.errors[
                                                            CREATE_SESSIONS_FIELD.PRICE_PER_HOUR
                                                            ] && (
                                                                <p>
                                                                    {
                                                                        formik.errors[
                                                                        CREATE_SESSIONS_FIELD.PRICE_PER_HOUR
                                                                        ]
                                                                    }
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        {/* {curentTabIndex === NUMBER_CONSTANTS.ZERO && <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Teaching Mode</label>
                                                    <Field
                                                        as="select"
                                                        name={CREATE_SESSIONS_FIELD.COURSE_TYPE}
                                                        placeholder="Select category"
                                                        className="email-input"
                                                        disabled={API_RESPONSE.TRUE}
                                                        value={`${NUMBER_CONSTANTS.TWO}`}
                                                        onChange={(e: any) => {
                                                            formik.setFieldValue(
                                                                CREATE_SESSIONS_FIELD.COURSE_TYPE,
                                                                e.target.value
                                                            );
                                                        }}
                                                    >
                                                        <option value={`${NUMBER_CONSTANTS.TWO}`}>{"Offline"}</option>
                                                    </Field>
                                                    <div className="errorMessage">
                                                        {formik.touched[CREATE_SESSIONS_FIELD.COURSE_TYPE] &&
                                                            formik.errors[
                                                            CREATE_SESSIONS_FIELD.COURSE_TYPE
                                                            ] && (
                                                                <p>
                                                                    {
                                                                        formik.errors[
                                                                        CREATE_SESSIONS_FIELD.COURSE_TYPE
                                                                        ]
                                                                    }
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>} */}
                                        {roleId === ADMIN_ROLES.RECREATIONAL_CAMP && <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Batch Size</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.BATCH_SIZE}
                                                        placeholder="Batch size"
                                                        className="email-input"
                                                        // disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                        onChange={(e: any) => {
                                                            formik.setFieldValue(
                                                                CREATE_SESSIONS_FIELD.BATCH_SIZE,
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[CREATE_SESSIONS_FIELD.BATCH_SIZE] &&
                                                            formik.errors[
                                                            CREATE_SESSIONS_FIELD.BATCH_SIZE
                                                            ] && (
                                                                <p>
                                                                    {
                                                                        formik.errors[
                                                                        CREATE_SESSIONS_FIELD.BATCH_SIZE
                                                                        ]
                                                                    }
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Repeat</label>
                                                    <div className="select-wrapper">
                                                        <Field
                                                            as="select"
                                                            name={CREATE_SESSIONS_FIELD.SLOT_MODE}
                                                            placeholder="Select category"
                                                            className="email-input"
                                                            disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                            value={formik.values[CREATE_SESSIONS_FIELD.SLOT_MODE]}
                                                            onChange={(e: any) => {
                                                                setRepeat(e.target.value);
                                                                formik.setFieldValue(
                                                                    CREATE_SESSIONS_FIELD.SLOT_MODE,
                                                                    e.target.value
                                                                );
                                                            }}
                                                        >
                                                            <option value={`${CREATE_SESSIONS_FIELD.DAILY}`}>Daily</option>
                                                            <option value={`${CREATE_SESSIONS_FIELD.WEEKDAYS}`}>Weekdays(Monday - Friday)</option>
                                                            <option value={`${CREATE_SESSIONS_FIELD.WEEKENDS}`}>Weekends(Saturday & Sunday)</option>
                                                            <option value={`${CREATE_SESSIONS_FIELD.CUSTOM}`}>Custom</option>
                                                        </Field>
                                                    </div>

                                                </div>
                                                <div className="errorMessage">
                                                    {formik.touched[CREATE_SESSIONS_FIELD.SLOT_MODE] &&
                                                        formik.errors[CREATE_SESSIONS_FIELD.SLOT_MODE] && (
                                                            <p>
                                                                {formik.errors[CREATE_SESSIONS_FIELD.SLOT_MODE]}
                                                            </p>
                                                        )}
                                                </div>
                                            </div>
                                        </div>

                                        {repeatType !== "custom" && <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Total Days</label>
                                                    <Field
                                                        name={CREATE_SESSIONS_FIELD.TOTAL_DAYS}
                                                        className="email-input"
                                                        placeholder="Total Days"
                                                        disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                        maxLength={2}
                                                        value={
                                                            formik.values[CREATE_SESSIONS_FIELD.TOTAL_DAYS]
                                                        }
                                                        //   onBlur={formik.handleBlur(CREATE_SESSIONS_FIELD.PRICE_PER_HOUR)}
                                                        onInput={numberOnly}
                                                        onPaste={numberOnly}
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[CREATE_SESSIONS_FIELD.TOTAL_DAYS] &&
                                                            formik.errors[CREATE_SESSIONS_FIELD.TOTAL_DAYS] && (
                                                                <p>
                                                                    {
                                                                        formik.errors[
                                                                        CREATE_SESSIONS_FIELD.TOTAL_DAYS
                                                                        ]
                                                                    }
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                {/* <span className="user-note">*Note: Total Days should be maximum 90 days</span> */}
                                            </div>
                                        </div>}

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Session Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DatePicker
                                                            className={"email-input date-picker"}
                                                            //   openTo="day"
                                                            views={["day", "month", "year"]}
                                                            value={new Date(startDate)}
                                                            disabled={CREATE_SESSIONS_FIELD.CUSTOM == repeatType ? false : true}
                                                            minDate={new Date()}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "medium",
                                                                    error: API_RESPONSE.FALSE,
                                                                },
                                                            }}
                                                            onChange={(date) => {
                                                                // const formattedDate = date
                                                                //   ? format(date, "yyyy-MM-dd")
                                                                //   : "";
                                                                setStartDate(date)
                                                                formik.setFieldValue(
                                                                    CREATE_SESSIONS_FIELD.SESSION_START_DATE,
                                                                    date
                                                                );
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    <div className="errorMessage">
                                                        {formik.touched[
                                                            CREATE_SESSIONS_FIELD.SESSION_START_DATE
                                                        ] &&
                                                            formik.errors[
                                                            CREATE_SESSIONS_FIELD.SESSION_START_DATE
                                                            ] && (
                                                                <p>
                                                                    {
                                                                        formik.errors[
                                                                        CREATE_SESSIONS_FIELD.SESSION_START_DATE
                                                                        ]
                                                                    }
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {repeatType === "custom" && (
                                            <div className="row row-wrap">
                                                <div className="col-md-12">
                                                    <div className="form-items">
                                                        <label className="form-label">Session End Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DatePicker
                                                                className={"email-input date-picker"}
                                                                //   openTo="day"
                                                                // views={["day", "month", "year"]}
                                                                value={new Date(endDate)}
                                                                disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                                minDate={new Date(startDate)}
                                                                maxDate={new Date(fixedEndDate)}
                                                                onChange={(e: any) => {
                                                                    setEndDate(new Date(e))
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        size: "medium",
                                                                        error: API_RESPONSE.FALSE,
                                                                    },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                        <div className="errorMessage">
                                                            {formik.touched[
                                                                CREATE_SESSIONS_FIELD.SESSION_START_DATE
                                                            ] &&
                                                                formik.errors[
                                                                CREATE_SESSIONS_FIELD.SESSION_START_DATE
                                                                ] && (
                                                                    <p>
                                                                        {
                                                                            formik.errors[
                                                                            CREATE_SESSIONS_FIELD.SESSION_START_DATE
                                                                            ]
                                                                        }
                                                                    </p>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {repeatType === "custom" && (
                                            <div className="row row-wrap">
                                                <div className="col-md-12">
                                                    <div className="form-items">
                                                        <label className="form-label">Repeat on</label>

                                                        <div className="day-wrapper">
                                                            <Tooltip title="Sunday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => {
                                                                        if (mode === MODES.CREATE)
                                                                            onClickDay(NUMBER_CONSTANTS.SIX)
                                                                    }
                                                                    }
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.SIX)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >
                                                                    S
                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Monday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => { if (mode === MODES.CREATE) onClickDay(NUMBER_CONSTANTS.ZERO) }}
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.ZERO)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >

                                                                    M

                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Tuesday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => { if (mode === MODES.CREATE) onClickDay(NUMBER_CONSTANTS.ONE) }}
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.ONE)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >

                                                                    T


                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Wednesday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => { if (mode === MODES.CREATE) onClickDay(NUMBER_CONSTANTS.TWO) }}
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.TWO)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >

                                                                    W

                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Thursday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => { if (mode === MODES.CREATE) onClickDay(NUMBER_CONSTANTS.THREE) }}
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.THREE)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >

                                                                    T

                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Friday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => { if (mode === MODES.CREATE) onClickDay(NUMBER_CONSTANTS.FOUR) }}
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.FOUR)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >

                                                                    F

                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Saturday" >
                                                                <div
                                                                    className="day-wrap"
                                                                    onClick={() => { if (mode === MODES.CREATE) onClickDay(NUMBER_CONSTANTS.FIVE) }}
                                                                    style={
                                                                        customSelectedDays.includes(NUMBER_CONSTANTS.FIVE)
                                                                            ? {
                                                                                backgroundColor: "rgb(26,115,232)",
                                                                                color: "#FFFFFF",
                                                                            }
                                                                            : {
                                                                                backgroundColor: "rgb(241,243,244)",
                                                                                color: "#000",
                                                                            }
                                                                    }
                                                                >

                                                                    S

                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                    {
                                                        formSubmitted && customSelectedDays.length === NUMBER_CONSTANTS.ZERO && <div className="errorMessage">
                                                            <p>Please select repeat on days</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        <div className="row row-wrap">
                                            <div className="col-md-6">
                                                <div className="form-items">
                                                    <label className="form-label">Slot Start Time</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={["TimePicker"]}>
                                                            <TimePicker
                                                                value={startTime}
                                                                format="hh:mm a"
                                                                onChange={(e: any) => {
                                                                    setStartTime(e.$d);
                                                                }}
                                                                disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                                className="email-input"
                                                            // label="Slot Start time"
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                    <div className="errorMessage">
                                                        {formSubmitted && !startTime && <div className="errorMessage">
                                                            <p>Please enter slot start time</p>
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                            {curentTabIndex === NUMBER_CONSTANTS.ONE && <div>
                                                <p className="user-note">Note: Session will be created for 15mins from the start time</p>
                                            </div>}
                                            {curentTabIndex === NUMBER_CONSTANTS.ZERO && <div className="col-md-6">
                                                <div className="form-items">
                                                    <label className="form-label">Slot End Time</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={["TimePicker"]}>
                                                            <TimePicker
                                                                value={endTime}
                                                                format="hh:mm a"
                                                                onChange={(e: any) => {
                                                                    setEndTime(e.$d);
                                                                }}
                                                                // maxTime={new Date(0, 0, 0, 18, 0)}
                                                                disabled={mode === MODES.EDIT ? API_RESPONSE.TRUE : API_RESPONSE.FALSE}
                                                                className="email-input"
                                                            // label="Slot End time"
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                    <div className="errorMessage">
                                                        {formSubmitted && !endTime && <div className="errorMessage">
                                                            <p>Please enter slot end time</p>
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>

                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div
                                                    className="form-items"
                                                    onDragOver={handleDragOver}
                                                    onDrop={(e: any) => {
                                                        handleDrop(e);
                                                    }}
                                                    onDragEnter={handleDragEnter}
                                                    onDragLeave={handleDragLeave}
                                                    ref={uploadFileRef}
                                                >
                                                    <label className="form-label">
                                                        Camp Images
                                                    </label>

                                                    <div className="syllabus-upload-file-wrapper">
                                                        <div className="upload-content">
                                                            <img src={uploadImage} alt="Learn and Play" />
                                                            <div className="text-content">
                                                                <p className="select-text">
                                                                    Slecet a file or drag and drop here
                                                                </p>
                                                                <p className="file-text mb-2">
                                                                    Recommended size: 640x671 with JPG,PNG
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <input
                                                            type="file"
                                                            accept="image/png, image/jpg, image/jpeg, image/svg"
                                                            className="input-upload"
                                                            onChange={handleChange}
                                                            ref={uploadFileRef}
                                                        />
                                                        <input
                                                            type="file"
                                                            accept="image/png, image/jpg, image/jpeg, image/svg"
                                                            className="input-upload"
                                                            onChange={handleChange}
                                                            ref={uploadFileBtnRef}
                                                            style={{ display: "none" }}
                                                        />
                                                        <div className="select-btn-wrap">
                                                            <button
                                                                className="select-file-btn"
                                                                onClick={handleBtnClick}
                                                            >
                                                                SELECT FILE
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="errorMessage">
                                                        {formik.touched[
                                                            CREATE_SESSIONS_FIELD.SYLLABUS_FILE_REQUIRED
                                                        ] &&
                                                            formik.errors[
                                                            CREATE_SESSIONS_FIELD.SYLLABUS_FILE_REQUIRED
                                                            ] && (
                                                                <p>
                                                                    {
                                                                        formik.errors[
                                                                        CREATE_SESSIONS_FIELD.SYLLABUS_FILE_REQUIRED
                                                                        ]
                                                                    }
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                {syllabusFile?.length > 0 && (
                                                    <div className="certificates-wrapper row">
                                                        {syllabusFile?.map((file: any, index: any) => (
                                                            <div className="col-md-4 col-wrap">
                                                                <img
                                                                    className="drive-img"
                                                                    src={coverImageIcon}
                                                                    onClick={() => {
                                                                        onFilerViewerDialogOpen(file);
                                                                    }}
                                                                />

                                                                <div className="close_icon_button">
                                                                    <img
                                                                        src={close}
                                                                        alt="Learn and Play"
                                                                        className="close"
                                                                        onClick={() => { handleDelete(index) }}
                                                                    />
                                                                </div>

                                                                <p className="pdf-title">{file.split("/")[file.split("/").length - 1]}</p>
                                                            </div>


                                                        ))}
                                                    </div>
                                                )}

                                                {/* {coverImage?.map((image: any, index: any) => {
                                                    return (
                                                        <div className="image-list" key={index + 1}>
                                                            <div className="image-text-wrap">
                                                                <img src={coverImageIcon} />
                                                                <p>{image.split("/")[image.split("/")?.length - 1]}</p>.
                                                                <p className="preview-text" onClick={() => {
                                                                    onFilerViewerDialogOpen(image);
                                                                }}>preview</p>
                                                            </div>
                                                            <div>
                                                                <CloseIcon className="closeIcon" onClick={() => { onDeleteImage(index) }} />
                                                            </div>


                                                        </div>
                                                    )
                                                })} */}
                                            </div>
                                        </div>
                                        {syllabusFile?.length === 0 && curentTabIndex === NUMBER_CONSTANTS.ZERO && formSubmitted && (
                                            <div className="errorMessage">
                                                <p>{"Please upload  camp Image"}</p>
                                            </div>
                                        )}


                                        <div className="row row-wrap">
                                            <div className="col-md-12">
                                                <div className="form-items">
                                                    <label className="form-label">Description</label>
                                                    <Field as="textarea"
                                                        name={CREATE_SESSIONS_FIELD.DESCRIPTION}
                                                        className="text_area-input"
                                                        placeholder="Description"
                                                        value={formik.values[CREATE_SESSIONS_FIELD.DESCRIPTION]}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e: any) => {
                                                            formik.setFieldValue(
                                                                CREATE_SESSIONS_FIELD.DESCRIPTION,
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="submit-btn-wrapper row-wrap">
                                            <button className="btn btn-danger cancel-btn" onClick={() => { onClose(); }}>
                                                Cancel
                                            </button>
                                            <>{console.log(status === "approved", "btn")}</>
                                            {(status === "approved" || status === "") && <button
                                                className="btn btn-success submit-btn"
                                                type="submit"
                                                onClick={() => {
                                                    setFormSubmitted(API_RESPONSE.TRUE);
                                                    formik.handleSubmit();
                                                }}
                                            >
                                                Submit
                                            </button>
                                            }
                                        </div>
                                    </div>

                                </DialogContent>
                            </>

                        )
                    }}
                </Formik>

                <CategoryValidationDialog
                    open={open}
                    onClose={handleClose}
                    message={categoryValidationMessage}
                    update={putValidationCategory}
                />

            </Dialog>
        </div>
    );
};

export default CampCreateSessionDialog;